import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

import styles from "./Icon.module.scss";
import { IconProps } from "./types";

/**
 * Icon component that renders icons from the streaming icons font
 *
 * @param icon - The icon to display from the StreamingIcons enum
 * @param className - Additional CSS class for styling
 * @param attr - Additional HTML attributes to pass to the rendered element
 *
 * @returns The rendered icon component as a React element
 *
 * @example
 * ```tsx
 * <Icon icon={StreamingIcons.Play} />
 * ```
 */
const Icon = ({ icon, className, ...attr }: IconProps) => {
  const iconClass = `icon-${icon}`;
  const cn = classNames(styles["icon"], iconClass, className);

  return (
    <i className={cn} aria-hidden="true" {...attr}>
      {" "}
    </i>
  );
};

export { Icon, StreamingIcons };
